import styled from 'styled-components';

import { StyledPill } from '@common/components/Pill/Pill.styled';

export const PillsFavoritesWrapper = styled.div`
  display: flex;
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 5)}
`;

export const PillsWrapper = styled.div`
  display: grid;
  grid-auto-columns: min-content;
  grid-auto-flow: column;
  ${({ theme }) => theme.getFluidSpacing('grid-column-gap', 'scale', 6)};
  width: 100%;
  margin-top: 0.1rem;

  ${StyledPill} {
    ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 14)}
  }
`;
